<template>
  <div
    class="notification-bar"
    :class="{ show: showPopup }"
  >
    <div class="notification-content">
      <div class="notification-message d-flex align-items-center">
        <div v-if="isIos">
          <span class="badge-custom me-2">{{ $t('install_app.install') }}</span>
          {{ $t('install_app.open_safari') }}
          <strong>{{ $t('install_app.share') }}</strong>
          (<img
            :src="shareIcon"
            alt="Share icon"
            class="me-1"
          >),
          {{ $t('install_app.then') }}
          <strong>"{{ $t('install_app.add_to_home') }}"</strong>.
        </div>
        <div
          v-else
          class="w-100 d-flex justify-content-center"
        >
          <div class="d-flex flex-column flex-sm-row align-items-center text-center">
            <span
              class="badge-custom me-0 me-sm-2 mb-2 mb-sm-0"
              @click="installApp"
            >
              {{ $t('install_app.install') }}
              <img
                :src="downloadIcon"
                alt="Download icon"
                class="ms-1 mb-1"
              >
            </span>
            <span>
              {{ $t('install_app.better_exp') }}
            </span>
          </div>
        </div>
      </div>
      <button
        class="close-button"
        aria-label="Close notification"
        @click="closePopup"
      >
        ×
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useInstallPrompt from '@/composables/useInstallPrompt';

export default defineComponent({
  name: 'InstallPromptComponent',
  setup() {
    const { showPopup, isIos, shareIcon, downloadIcon, installApp, closePopup } = useInstallPrompt();
    return { showPopup, isIos, shareIcon, downloadIcon, installApp, closePopup };
  },
});
</script>

<style scoped>
.notification-bar {
  position: fixed;
  top: -130px;
  left: 0;
  right: 0;
  background: var(--mcb-color-teal-original);
  color: #fff;
  padding: 1rem;
  text-align: center;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: top 0.3s ease;

}

.notification-bar.show {
  top: 0;
}

.notification-content {
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-family: system-ui, -apple-system, sans-serif;
}

.notification-message {
  font-size: 15px;
  margin-right: 24px;
}

.close-button {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0px !important;
  font-size: 25px;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.close-button:hover {
  opacity: 1;
}

@media (max-width: 576px) {
  .notification-message {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .notification-content {
    flex-direction: row;
    gap: 12px;
  }
  .notification-message {
    font-size: 13px;
    margin-right: 0;
  }
}

.badge-custom {
  background: #fff;
  color: var(--color-primary-dark-grey);
  border-color: var(--btn-primary-border-color);
  cursor: pointer;
  border-radius: 6px;
  padding: 0.2rem 0.5rem;
}

.badge-custom:hover {
  background: var(--btn-primary-hover-background);
  border-color: var(--btn-primary-hover-border-color);
  color: var(--btn-primary-hover-font-color);
}
</style>
